import {
  Button,
  Checkbox,
  FormControlLabel,
  Select,
  TextField,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ReactComponent as SearchIcon } from '../../../assets/images/Search.svg';
import { ExpandMore } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { useHook as customerHook } from './useHook';
import { useHook as EquipmentsDashboard } from '../hardware/equipments/useHook';
interface FilterDrawer {
  fliterCloseDrawer: () => void;
  filterSubmit: (data: any) => void;
  filterDrawerData?: any;
}

const FilterDrawer: React.FC<FilterDrawer> = ({
  fliterCloseDrawer,
  filterSubmit,
  filterDrawerData,
}) => {
  const userRole = localStorage.getItem('role');

  const { fetchGetCustomerFilter, fetchGetDealerCustomerFilter } =
    customerHook();
  const { fetchGetListCategory, fetchDealerGetListCategory } =
    EquipmentsDashboard();
  const { customerFilter } = useSelector(
    (state: any) => state.customerManagement,
  );
  const { allCategory } = useSelector((state: any) => state.equipments);
  const [equipment, setEquipment] = React.useState<string[]>([]);
  const [categoryName, setCategoryName] = React.useState<string[]>([]);
  const [subcategoryName, setSubcategoryName] = React.useState<string[]>([]);
  const [serialNumber, setSerialNumber] = React.useState<string[]>([]);
  const [filteredEquipment, setFilteredEquipment] = useState<any[]>([]);
  const [filteredCategory, setFilteredCategory] = useState<any[]>([]);
  const [filteredSubCategory, setFilteredSubCategory] = useState<any[]>([]);
  const [filterStoreCategory, setFilterStoreCategory] = useState<any[]>([]);
  const [filterStoreSubCategory, setFilterStoreSubCategory] = useState<any[]>(
    [],
  );
  const [filteredSerialNumber, setFilteredSerialNumber] = useState<any[]>([]);
  const [isFilterActive, setFilterActive] = useState(false);

  //get Category
  const handleGetCategory = () => {
    if (userRole === 'dealer') {
      const updateCategory = customerFilter?.category?.map(
        (data: { categoryName: any }) => data?.categoryName,
      );
      setFilteredCategory(updateCategory ? updateCategory : []);
      setFilterStoreCategory(updateCategory ? updateCategory : []);
    } else {
      const updateCategory = allCategory?.map(
        (data: { categoryName: any }) => data?.categoryName,
      );
      setFilteredCategory(updateCategory ? updateCategory : []);
      setFilterStoreCategory(updateCategory ? updateCategory : []);
    }
  };
  //get SubCategory
  const handleGetSubCategory = async () => {
    if (userRole === 'dealer') {
      // Filter based on exact match for the category name
      const upDateSubCategory = customerFilter?.category
        ?.filter(
          (category: { categoryName: any; subCategories: any }) =>
            categoryName.includes(category.categoryName) &&
            Array.isArray(category.subCategories),
        )
        .flatMap((category: { subCategories: any }) => category.subCategories);
      setFilteredSubCategory(upDateSubCategory ? upDateSubCategory : []);
      setFilterStoreSubCategory(upDateSubCategory ? upDateSubCategory : []);

      //subCategory selection values
      const selectSubCategory = upDateSubCategory?.filter((data: string) =>
        subcategoryName?.includes(data),
      );
      setSubcategoryName(selectSubCategory ? selectSubCategory : []);
    } else {
      // Filter based on exact match for the category name
      const upDateSubCategory = allCategory
        .filter(
          (category: { categoryName: any; subCategories: any }) =>
            categoryName.includes(category.categoryName) &&
            Array.isArray(category.subCategories),
        )
        .flatMap((category: { subCategories: any }) => category.subCategories);
      setFilteredSubCategory(upDateSubCategory ? upDateSubCategory : []);
      setFilterStoreSubCategory(upDateSubCategory ? upDateSubCategory : []);

      //subCategory selection values
      const selectSubCategory = upDateSubCategory?.filter((data: string) =>
        subcategoryName?.includes(data),
      );
      setSubcategoryName(selectSubCategory ? selectSubCategory : []);
    }
  };

  useEffect(() => {
    handleGetSubCategory();
  }, [categoryName]);

  useEffect(() => {
    if (allCategory?.length > 0 && userRole !== 'dealer') {
      handleGetCategory();
    }
    if (customerFilter?.category?.length > 0 && userRole === 'dealer') {
      handleGetCategory();
    }
  }, [allCategory, customerFilter]);

  //setSelectionFilter
  useEffect(() => {
    if (filterDrawerData) {
      setEquipment(filterDrawerData?.equipment);
      setSubcategoryName(filterDrawerData?.subCategory);
      setCategoryName(filterDrawerData?.category);
      setSerialNumber(filterDrawerData?.serialNumber);
    }
  }, [filterDrawerData]);

  useEffect(() => {
    const isFilterActive =
      equipment?.length > 0 ||
      serialNumber?.length > 0 ||
      categoryName?.length > 0 ||
      subcategoryName?.length > 0;

    setFilterActive(isFilterActive);
  }, [equipment, serialNumber, categoryName, subcategoryName]);

  const handleSubmit = () => {
    const payload = {
      equipment: equipment,
      serialNumber: serialNumber,
      category: categoryName,
      subCategory: subcategoryName,
    };
    filterSubmit(payload);
  };

  useEffect(() => {
    if (userRole === 'dealer') {
      fetchGetDealerCustomerFilter();
      // if (!(allCategory?.length > 0)) {
      //   fetchDealerGetListCategory({});
      // }
    } else {
      fetchGetCustomerFilter();
      if (!(allCategory?.length > 0)) {
        fetchGetListCategory({});
      }
    }
  }, []);

  useEffect(() => {
    setFilteredEquipment(
      customerFilter?.equipment ? customerFilter?.equipment : [],
    );
    setFilteredSerialNumber(
      customerFilter?.serialnumber ? customerFilter?.serialnumber : [],
    );
    // setFilteredCategory(
    //   customerFilter?.category ? customerFilter?.category : [],
    // );
    // setFilteredSubCategory(
    //   customerFilter?.subCategory ? customerFilter?.subCategory : [],
    // );
  }, [customerFilter]);

  const handleEquipmentSearch = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const query = event.target.value.toLowerCase();
    const filtered = customerFilter?.equipment?.filter((equipment: string) =>
      equipment?.toLowerCase().includes(query),
    );
    setFilteredEquipment(filtered);
  };

  const handleSerialNumberSearch = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const query = event.target.value.toLowerCase();
    const filtered = customerFilter?.serialNumber?.filter(
      (serialNumber: string) => serialNumber?.toLowerCase().includes(query),
    );
    setFilteredSerialNumber(filtered);
  };

  const handleCategorySearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const query = event.target.value.toLowerCase();
    const filtered = filterStoreCategory?.filter((category: string) =>
      category?.toLowerCase().includes(query),
    );
    setFilteredCategory(filtered);
  };
  const handleSubCategorySearch = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const query = event.target.value.toLowerCase();
    const filtered = filterStoreSubCategory?.filter((category: string) =>
      category?.toLowerCase().includes(query),
    );
    setFilteredSubCategory(filtered);
  };

  const handleFilterSelection = (
    selectName: string | undefined,
    field: string,
  ) => {
    if (!selectName) return;
    if (field === 'equipment') {
      setEquipment((prevselected) => {
        if (prevselected.includes(selectName)) {
          const updatedData = prevselected.filter(
            (names) => names !== selectName,
          );
          return updatedData;
        } else {
          const updatedData = [...prevselected, selectName];
          return updatedData;
        }
      });
    } else if (field === 'category') {
      setCategoryName((prevselected) => {
        if (prevselected.includes(selectName)) {
          const updatedData = prevselected.filter(
            (names) => names !== selectName,
          );
          return updatedData;
        } else {
          const updatedData = [...prevselected, selectName];
          return updatedData;
        }
      });
    } else if (field === 'subCategory') {
      setSubcategoryName((prevselected) => {
        if (prevselected.includes(selectName)) {
          const updatedData = prevselected.filter(
            (names) => names !== selectName,
          );
          return updatedData;
        } else {
          const updatedData = [...prevselected, selectName];
          return updatedData;
        }
      });
    } else if (field === 'serialNumber') {
      setSerialNumber((prevselected) => {
        if (prevselected.includes(selectName)) {
          const updatedData = prevselected.filter(
            (names) => names !== selectName,
          );
          return updatedData;
        } else {
          const updatedData = [...prevselected, selectName];
          return updatedData;
        }
      });
    }
  };

  return (
    <div className="fliter-drawer-container">
      <div>
        <div className="fliter-drawer-header">
          <p className="fliter-drawer-header-content">Fliters</p>
          {/* <p className="fliter-drawer-header-text">Restore</p> */}
        </div>
        <div className="fliter-drawer-body">
          <div className="fliter-drawer-body-content">
            <p className="fliter-drawer-body-lable">Equipment</p>
            <Select
              labelId="demo-multiple-checkbox-label"
              id="demo-multiple-checkbox"
              className="create_controller-nodata_drawer_form_field_input"
              multiple
              displayEmpty
              value={equipment}
              onClose={() => setFilteredEquipment(customerFilter?.equipment)}
              renderValue={() => {
                if (equipment.length === 0 || !equipment) {
                  return (
                    <span className="filter_dropdown_placeholder_text">
                      Equipment Name
                    </span>
                  );
                }
                return equipment.join(', ');
              }}
              IconComponent={ExpandMore}
            >
              <div className="selectoption_content filter_dropdown-height">
                <div className="selectoption_search_content">
                  <TextField
                    className="selectoption_searchbar search-input"
                    variant="outlined"
                    placeholder="Search Equipment"
                    fullWidth
                    InputProps={{
                      startAdornment: <SearchIcon className="search_icon" />,
                    }}
                    onChange={handleEquipmentSearch}
                  />
                </div>
                <div className="selectoption_list_content">
                  {filteredEquipment?.map((equipmentName, index) => (
                    <div key={index} className="selectoption_list">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={equipment.includes(String(equipmentName))}
                            onChange={() => {
                              handleFilterSelection(
                                String(equipmentName),
                                'equipment',
                              );
                            }}
                          />
                        }
                        label={equipmentName}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </Select>
          </div>
          {/* <div className="fliter-drawer-body-content">
            <p className="fliter-drawer-body-lable">Serial Number</p>
            <Select
              labelId="demo-multiple-checkbox-label"
              id="demo-multiple-checkbox"
              className="create_controller-nodata_drawer_form_field_input"
              multiple
              displayEmpty
              value={serialNumber}
              onClose={() =>
                setFilteredSerialNumber(customerFilter?.serialnumber)
              }
              renderValue={() => {
                if (serialNumber.length === 0 || !serialNumber) {
                  return (
                    <span className="filter_dropdown_placeholder_text">
                      Searial Number
                    </span>
                  );
                }
                return serialNumber.join(', ');
              }}
              IconComponent={ExpandMore}
            >
              <div className="selectoption_content filter_dropdown-height">
                <div className="selectoption_search_content">
                  <TextField
                    className="selectoption_searchbar search-input"
                    variant="outlined"
                    placeholder="Search Serial Number"
                    fullWidth
                    InputProps={{
                      startAdornment: <SearchIcon className="search_icon" />,
                    }}
                    onChange={handleSerialNumberSearch}
                  />
                </div>
                <div className="selectoption_list_content">
                  {filteredSerialNumber?.map((serial, index) => (
                    <div key={index} className="selectoption_list">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={serialNumber.includes(String(serial))}
                            onChange={() => {
                              handleFilterSelection(
                                String(serial),
                                'serialNumber',
                              );
                            }}
                          />
                        }
                        label={serial}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </Select>
          </div> */}

          <div className="fliter-drawer-body-content">
            <p className="fliter-drawer-body-lable">Category</p>
            <Select
              className="create_controller-nodata_drawer_form_field_input"
              multiple
              displayEmpty
              value={categoryName}
              onClose={handleGetCategory}
              renderValue={() => {
                if (categoryName.length === 0) {
                  return (
                    <span className="filter_dropdown_placeholder_text">
                      Category
                    </span>
                  );
                }
                return categoryName.join(', ');
              }}
              IconComponent={ExpandMore}
            >
              <div className="selectoption_content filter_dropdown-height">
                <div className="selectoption_search_content">
                  <TextField
                    className="selectoption_searchbar search-input"
                    variant="outlined"
                    placeholder="Search Category"
                    fullWidth
                    InputProps={{
                      startAdornment: <SearchIcon className="search_icon" />,
                    }}
                    onChange={handleCategorySearch}
                  />
                </div>
                <div className="selectoption_list_content">
                  {filteredCategory?.map((category, index) => (
                    <div key={index} className="selectoption_list">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={categoryName.includes(String(category))}
                            onChange={() => {
                              handleFilterSelection(
                                String(category),
                                'category',
                              );
                            }}
                          />
                        }
                        label={category}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </Select>
          </div>
          <div className="fliter-drawer-body-content">
            <p className="fliter-drawer-body-lable">Subcategory</p>
            <Select
              className="create_controller-nodata_drawer_form_field_input"
              multiple
              disabled={filterStoreSubCategory?.length == 0}
              displayEmpty
              value={subcategoryName}
              onClose={handleGetSubCategory}
              renderValue={() => {
                if (subcategoryName.length === 0) {
                  return (
                    <span className="filter_dropdown_placeholder_text">
                      Subcategory
                    </span>
                  );
                }
                return subcategoryName.join(', ');
              }}
              IconComponent={ExpandMore}
            >
              <div className="selectoption_content filter_dropdown-height">
                <div className="selectoption_search_content">
                  <TextField
                    className="selectoption_searchbar search-input"
                    variant="outlined"
                    placeholder="Search Subcategory"
                    fullWidth
                    InputProps={{
                      startAdornment: <SearchIcon className="search_icon" />,
                    }}
                    onChange={handleSubCategorySearch}
                  />
                </div>
                <div className="selectoption_list_content">
                  {filteredSubCategory?.map((subCategory, index) => (
                    <div key={index} className="selectoption_list">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={subcategoryName.includes(
                              String(subCategory),
                            )}
                            onChange={() => {
                              handleFilterSelection(
                                String(subCategory),
                                'subCategory',
                              );
                            }}
                          />
                        }
                        label={subCategory}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </Select>
          </div>
        </div>
      </div>
      <div className="create_controller-nodata_drawer_button_content">
        <div className="create_controller-nodata_drawer_button">
          <Button
            variant="text"
            className="cencel_button"
            onClick={fliterCloseDrawer}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
            className={
              isFilterActive ? 'save_button' : 'save_button disabled_button'
            }
            disabled={!isFilterActive}
          >
            Apply
          </Button>
        </div>
      </div>
    </div>
  );
};

const MemoizedComponent = React.memo(FilterDrawer);
export default MemoizedComponent;
